<template>
  <div class="col-xxl-12 col-xl-12 mb-20">
    <div v-if="saveError" class="alert alert-danger" role="alert">
      Ju lutem rishikoni gabimet në formë.
    </div>

    <div class="btn-toggle mb-20" role="group" aria-label="Zgjedhni tipin e klientit">
      <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked />
      <label for="btnradio1" @click="individual = true" :aria-pressed="individual" class="btn-toggle-label">
        <span class="label-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" fill="currentColor" />
            <path d="M4 20c0-2.21 3.58-4 8-4s8 1.79 8 4v1H4v-1z" fill="currentColor" opacity="0.9" />
          </svg>
        </span>
        <span class="label-text">Person fizik</span>
      </label>

      <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" />
      <label for="btnradio2" @click="individual = false" :aria-pressed="!individual" class="btn-toggle-label">
        <span class="label-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M3 13h18v8H3v-8z" fill="currentColor" />
            <path d="M7 9h10v4H7V9z" fill="currentColor" opacity="0.9" />
            <path d="M5 5h2v2H5V5zm4 0h2v2H9V5zm4 0h2v2h-2V5z" fill="currentColor" />
          </svg>
        </span>
        <span class="label-text">Biznes</span>
      </label>
    </div>

    <div class="contact-form">
      <form id="contact-form">
        <div class="row">
          <h3>Të dhënat personale</h3>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="name"
              type="text"
              :placeholder="Emri"
              v-model="member.firstName"
              :class="{ 'is-invalid': errors.firstName }"
            />
            <span v-if="errors.firstName" class="invalid-feedback">{{
              errors.firstName
            }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="surname"
              type="text"
              :placeholder="Mbiemri"
              v-model="member.lastName"
              :class="{ 'is-invalid': errors.lastName }"
            />
            <span v-if="errors.lastName" class="invalid-feedback">{{
              errors.lastName
            }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <select v-model="member.city" :class="{ 'is-invalid': errors.city }">
              <option v-for="city of cities" :key="city.id" :value="city.id">
                {{ city.city }}
              </option>
            </select>
            <span v-if="errors.city" class="invalid-feedback">{{ errors.city }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="address"
              type="text"
              placeholder="Adresa"
              v-model="member.address"
              :class="{ 'is-invalid': errors.address }"
            />
            <span v-if="errors.address" class="invalid-feedback">{{ errors.address }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="phone"
              type="text"
              placeholder="Telefoni"
              v-model="member.phone"
              v-maska="'04#-###-###'"
              :class="{ 'is-invalid': errors.phone }"
            />
            <span v-if="errors.phone" class="invalid-feedback">{{ errors.phone }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="email"
              type="email"
              placeholder="Email"
              v-model="member.email"
              :class="{ 'is-invalid': errors.email }"
            />
            <span v-if="errors.email" class="invalid-feedback">{{ errors.email }}</span>
          </div>

          <h3>Të dhënat e veturës</h3>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <select
              v-model="vehicle.brand"
              :class="{ 'is-invalid': errors.vehicleBrand }"
            >
              <option v-for="car of cars" :key="car.name" :value="car.id">
                {{ car.name }}
              </option>
            </select>
            <span v-if="errors.vehicleBrand" class="invalid-feedback">{{
              errors.vehicleBrand
            }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="model"
              type="text"
              placeholder="Modeli i veturës"
              v-model="vehicle.model"
              :class="{ 'is-invalid': errors.vehicleModel }"
            />
            <span v-if="errors.vehicleModel" class="invalid-feedback">{{
              errors.vehicleModel
            }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="year"
              type="number"
              placeholder="Viti i prodhimit"
              v-model="vehicle.year"
              :class="{ 'is-invalid': errors.vehicleYear }"
            />
            <span v-if="errors.vehicleYear" class="invalid-feedback">{{
              errors.vehicleYear
            }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="plates"
              type="text"
              placeholder="Targat"
              v-model="vehicle.licensePlate"
              v-maska="'##-###-SS'"
              :class="{ 'is-invalid': errors.licensePlate }"
            />
            <span v-if="errors.licensePlate" class="invalid-feedback">{{
              errors.licensePlate
            }}</span>
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 mb-20">
            <input
              name="registration"
              type="text"
              placeholder="Numri i shasise"
              v-model="vehicle.chassisNumber"
              @input="formatLicensePlate"
              :class="{ 'is-invalid': errors.chassisNumber }"
            />
            <span v-if="errors.chassisNumber" class="invalid-feedback">{{
              errors.chassisNumber
            }}</span>
          </div>

          <div class="col-xxl-12 col-xl-12 mb-20">
            <button :disabled="isLoading" @click.prevent="registerMember" class="tp-btn">
              <span v-if="isLoading">Duke u dërguar...</span>
              <span v-else>Anëtaresohu</span>
            </button>
          </div>
        </div>
      </form>
    </div>

    <invoice-print
      v-show="false"
      :member="member"
      :vehicles="vehicles"
      ref="InvoiceFrom"
      :title="title"
      :discount="discount"
    />
  </div>
</template>

<style scoped>
.is-invalid {
  border-color: red;
}
.invalid-feedback {
  color: red;
  font-size: 0.85em;
  margin-top: 4px;
}
</style>

<style scoped>
/* Modern toggle styles for individual/business switch */
.btn-toggle {
  display: inline-flex;
  background: #f4f6f8;
  border-radius: 999px;
  padding: 4px;
  gap: 6px;
}
.btn-check { display: none; }
.btn-toggle-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  cursor: pointer;
  color: #354354;
  font-weight: 600;
  user-select: none;
  transition: all 180ms ease;
}
.btn-toggle-label .label-icon { font-size: 16px; display: inline-flex; align-items: center; justify-content: center; width: 20px; height: 20px; }
.btn-toggle-label .label-icon svg { width: 16px; height: 16px; display: block; color: currentColor; }
.btn-toggle-label[aria-pressed="true"], .btn-check:checked + .btn-toggle-label {
  background: linear-gradient(90deg,#ff5a5f,#ff8966);
  color: #fff;
  box-shadow: 0 6px 18px rgba(255,88,90,0.18);
  transform: translateY(-1px);
}
.btn-toggle-label:focus { outline: 2px solid rgba(0,123,255,0.2); }

@media (max-width: 576px) {
  .btn-toggle-label { padding: 6px 10px; font-size: 14px; }
}
</style>

<script>
import cities from '@/json/cities.json'
import cars from '@/json/car_brands.json'
import InvoicePrint from '../Invoice/InvoicePrint.vue'

export default {
  props: ['packageId', 'price', 'title', 'discount'],
  components: {
    InvoicePrint
  },
  data() {
    return {
      isLoading: false,
      vehicles: [],
      cars: cars,
      cities: cities,
      member: {
        id: null,
        firstName: '',
        lastName: '',
        city: 0,
        address: '',
        phone: '04',
        clientType: 1,
        grossAmount: 0,
        tax: 0,
        startDate: '',
        endDate: null,
        status: '',
        agent: 1,
        subagent: 1,
        clientID: '',
        email: '',
        Vehicle: []
      },
      vehicle: {
        id: null,
        brand: 0,
        model: '',
        licensePlate: '',
        chassisNumber: '',
        package: 0,
        withTaxes: true,
        year: null
      },
      show: false,
      errors: {},
      saveError: false,
      Emri: 'Emri dhe Mbiemri',
      Mbiemri: 'Numri personal',
      individual: true
    }
  },
  methods: {
    generateDoc() {
      this.$refs.InvoiceFrom.exportToPDF()
    },
    clearError(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },
    validateField(field, value) {
      switch (field) {
        case 'firstName':
          value.trim().length < 3
            ? this.errors.firstName = this.Emri +' duhet të ketë së paku 3 karaktere'
            : this.clearError('firstName');
          break;
        case 'lastName':
          value.trim().length < 3
            ? this.errors.lastName = this.Mbiemri +' duhet të ketë së paku 3 karaktere'
            : this.clearError('lastName');
          break;
        case 'city':
          value === 0
            ? this.errors.city = 'Ju lutem zgjidhni qytetin'
            : this.clearError('city');
          break;
        case 'address':
          value.trim().length === 0
            ? this.errors.address = 'Ju lutem plotësoni adresën'
            : this.clearError('address');
          break;
        case 'phone':
          if (value.trim() === '') {
            this.errors.phone = 'Ju lutem plotësoni numrin e telefonit';
          } else if (!/^04\d-\d{3}-\d{3}$/.test(value)) {
            this.errors.phone = 'Numri i telefonit duhet të jetë në formatin 04#-###-###';
          } else {
            this.clearError('phone');
          }
          break;
        case 'email':
          value.trim() === '' || !/^[\w.-]+@[\w.-]+\.\w{2,4}$/.test(value)
            ? this.errors.email = 'Ju lutem plotësoni një email valid'
            : this.clearError('email');
          break;
        case 'vehicleBrand':
          value === 0
            ? this.errors.vehicleBrand = 'Zgjedhni markën e veturës'
            : this.clearError('vehicleBrand');
          break;
        case 'vehicleModel':
          value.trim().length < 3
            ? this.errors.vehicleModel = 'Specifikoni modelin e veturës'
            : this.clearError('vehicleModel');
          break;
        case 'vehicleYear': {
          const year = Number(value);
          const currentYear = new Date().getFullYear();
          if (!year || year < 1990 || year > currentYear) {
            this.errors.vehicleYear = `Viti i prodhimit duhet të jetë mes 1990 dhe ${currentYear}`;
          } else {
            this.clearError('vehicleYear');
          }
          break;
        } // close block for vehicleYear
          case 'licensePlate':
          value.trim().length === 0
            ? this.errors.licensePlate = 'Ju lutem plotësoni targat e veturës'
            : this.clearError('licensePlate');
          break;
        case 'chassisNumber':
          value.trim().length === 0
            ? this.errors.chassisNumber = 'Ju lutem plotësoni numrin e shasise'
            : this.clearError('chassisNumber');
          break;
      }
    },
    registerMember() {
      if (this.isLoading) return

      this.errors = {}
      this.saveError = false

      this.validateField('firstName', this.member.firstName);
      this.validateField('lastName', this.member.lastName);
      this.validateField('city', this.member.city);
      this.validateField('address', this.member.address);
      this.validateField('phone', this.member.phone);
      this.validateField('email', this.member.email);

      this.validateField('vehicleBrand', this.vehicle.brand);
      this.validateField('vehicleModel', this.vehicle.model);
      this.validateField('vehicleYear', this.vehicle.year);
      this.validateField('licensePlate', this.vehicle.licensePlate);
      this.validateField('chassisNumber', this.vehicle.chassisNumber);

      if (Object.keys(this.errors).length > 0) {
        this.saveError = true;
        return;
      }

      this.isLoading = true;
      this.vehicles = [];
      this.vehicle.package = this.Package;
      this.vehicles.push(this.vehicle);

      this.member.Vehicle = this.vehicles;
      // attach selected package discount to member for invoice
      this.member.discount = Number(this.discount) || 0;
      this.member.grossAmount = this.vehicles.length * (this.price / 1.18);
      this.member.tax = this.vehicles.length * this.price - this.member.grossAmount;
      this.member.status = 1;
      this.member.agent = 0;
      this.member.subagent = 0;
      this.member.startDate = new Date();

      this.$store.dispatch('members/createMember', this.member).then((response) => {
        this.member = response.member;
        if (response.code === 200) {
          this.generateDoc();
          const totalAmount = (this.vehicles.length * this.price).toFixed(2);
          this.$router.push({ path: '/thanks', query: { success: true, invoiceNo: response.member?.clientID, amount: totalAmount } });
        }
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    resetMember() {
      this.member = {
        id: null,
        firstName: '',
        lastName: '',
        city: 1,
        address: '',
        phone: '',
        clientType: 1,
        grossAmount: 0,
        tax: 0,
        startDate: '',
        endDate: null,
        status: '',
        agent: 1,
        subagent: 1,
        clientID: '',
        email: '',
        Vehicle: []
      }
    },
    formatLicensePlate(event) {
      let inputValue = event.target.value;
      inputValue = inputValue.replace(/[^0-9a-zA-Z]/g, '').toUpperCase();
      this.vehicle.chassisNumber = inputValue;
    }
  },
  computed: {
    Package() {
      return this.packageId;
    }
  },
  watch: {
    individual(val) {
      if (!val) {
        this.Emri = 'Emri biznesit';
        this.Mbiemri = 'Numri i biznesit';
        this.member.clientType = 2;
      } else {
        this.Emri = 'Emri dhe Mbiemri';
        this.Mbiemri = 'Numri personal';
        this.member.clientType = 1;
      }
    },
    'vehicle.licensePlate': function (newVal) {
      this.vehicle.licensePlate = newVal.toUpperCase();
    }
  }
}
</script>
